import React from "react";
import Container from "./Container";
import { Link } from "react-router-dom";
import Logo from "../../../components/Logo/Logo";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-slate-200 bg-white py-10">
      <Container>
        <div className="flex flex-col items-center justify-between gap-6 lg:flex-row lg:gap-8">
          <Link
            to="/"
            className="group flex items-center gap-2 transition opacity-90 hover:opacity-100 no-underline text-lg"
          >
            <Logo />
          </Link>
          <p className="max-w-md text-center text-sm text-slate-500 lg:text-left">
            Find clients where they ask for help—Reddit & LinkedIn. No bidding
            wars. Just you and the right conversation.
          </p>
          <nav className="flex flex-wrap items-center justify-center gap-6 text-sm">
            <Link
              to="/terms-of-service"
              className="text-slate-500 transition hover:text-slate-900"
            >
              Terms
            </Link>
            <Link
              to="/privacy-policy"
              className="text-slate-500 transition hover:text-slate-900"
            >
              Privacy
            </Link>
            <Link
              to="/contact-us"
              className="text-slate-500 transition hover:text-slate-900"
            >
              Contact
            </Link>
          </nav>
        </div>
        <div className="mt-8 border-t border-slate-100 pt-6 text-center text-sm text-slate-400">
          &copy; {currentYear} LeadZLab. All rights reserved.
        </div>
      </Container>
    </footer>
  );
}
